import { Label, Select, Pagination as UswdsPagination } from '@trussworks/react-uswds';
import './pagination.scss';
import React from 'react';

export const defaultPageSizeOptions = [10, 20, 30, 50];

type PaginationProps = {
  currentPage: number;
  itemsPerPage: number;
  maxPageNumberButtons?: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  pageCount: number;
  pageSizeOptions?: number[];
  rightContent?: React.ReactNode;
  showPageSizeSelector?: boolean;
};

const Pagination = ({
  currentPage,
  itemsPerPage,
  maxPageNumberButtons = 7,
  onPageChange,
  onPageSizeChange = () => {},
  pageCount,
  pageSizeOptions = defaultPageSizeOptions,
  rightContent,
  showPageSizeSelector = true,
}: PaginationProps) => {
  const hasPages = pageCount > 0;
  const showPagination = pageCount > 0;

  const handlePrevClick = () => {
    const page = Math.max(0, Number(currentPage) - 1);
    onPageChange(page);
  };

  const handleNextClick = () => {
    const page = Number(currentPage) + 1;
    onPageChange(page);
  };

  // React.MouseEvent<HTMLButtonElement>
  const handlePageClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;
    const pageString = target?.innerText || 1;
    const page = Number(pageString);
    onPageChange(page);
  };

  const handlePageSizeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const pageSize = parseInt(e.target.value);
    onPageSizeChange(pageSize);
    onPageChange(1);
  };

  if (!hasPages && !rightContent) {
    return null;
  }

  return (
    <div className='pagination-container'>
      <div className='pagination-content'>
        <div className='pagination'>
          {showPagination && (
            <>
              <UswdsPagination
                className='margin-right-3 pagination-styles'
                currentPage={Number(currentPage)}
                maxSlots={maxPageNumberButtons}
                onClickNext={handleNextClick}
                onClickPageNumber={handlePageClick}
                onClickPrevious={handlePrevClick}
                pathname=''
                totalPages={pageCount}
              />
              {showPageSizeSelector && (
                <div className='pagination-size'>
                  <Label htmlFor='rows_per_page' className='pagination-text'>
                    rows per page:
                  </Label>
                  <Select
                    defaultValue={itemsPerPage}
                    id='rows_per_page'
                    name='rows_per_page'
                    onChange={handlePageSizeSelect}
                  >
                    {pageSizeOptions.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    ))}
                  </Select>
                </div>
              )}
              <span className='pagination-text'>
                {currentPage} of {pageCount} pages
              </span>
            </>
          )}
        </div>
      </div>
      {rightContent}
    </div>
  );
};

export default Pagination;
